import React from 'react';
import { ChatSidebarMobile } from './ChatSidebarMobile';
import { ChatContent } from './ChatContent';

interface ChatMobileProps {
  isSidebarOpen: boolean;
  onRequestCloseSidebar: () => void;
}

export const ChatMobile: React.FC<ChatMobileProps> = ({ isSidebarOpen, onRequestCloseSidebar }) => {
  return (
    <div className="relative h-full w-full min-h-0 flex flex-col">
      {/* Always render chat content underneath */}
      <div className="flex-1 min-h-0">
        <ChatContent className="h-full" isMobile={true} />
      </div>

      {/* Half-screen sidebar overlay when opened */}
      {isSidebarOpen && (
        <>
          <div className="fixed inset-y-0 left-0 w-3/4  z-50 border-r border-white/10">
            <ChatSidebarMobile onChatSelect={onRequestCloseSidebar} />
          </div>
          {/* Click-off backdrop on the right half to close */}
          <div
            className="fixed inset-y-0 left-3/4 right-0 /30 backdrop-blur-[1px] z-40"
            onClick={onRequestCloseSidebar}
          />
        </>
      )}
    </div>
  );
};
